import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import Grid from "@mui/material/Grid";

import Badge from "components/Badge";
import StyledLine from "components/List/components/StyledLine";
import CancelButtonStyled from "components/button/CancelButtonStyled";
import {ListContext} from "components/List/context/ListContext";

import ShippingMethodName from "./ShippingMethodName";
import {SyliusCandidatesContext} from "views/shippingMethods/context/SyliusCandidatesContext";

SyliusCandidateLine.propTypes = {
    candidate: PropTypes.object.isRequired
};

// A method on Sylius the Marketplace does not know: its orders fall back on another method until configured.
function SyliusCandidateLine({candidate}) {
    const {openCreateDialog} = useContext(ListContext);
    const {setPrefill} = useContext(SyliusCandidatesContext);

    return (
        <Grid item container sx={{padding: '8px 0'}}>
            <StyledLine justifyContent={"space-between"} alignItems={'center'}>
                <Grid item container xs={4} columnSpacing={2} alignItems={'center'}>
                    <Grid item>
                        <ShippingMethodName name={candidate.name || candidate.code} />
                    </Grid>
                </Grid>
                <Grid item container xs={4} columnSpacing={2} justifyContent={'space-between'}>
                    <Grid item>
                        <Badge rounded color={'warning'}>
                            <FormattedMessage id={'shippingMethods.sylius.missing'}/>
                        </Badge>
                    </Grid>
                    <Grid item>
                        {candidate.code}
                    </Grid>
                </Grid>
                <Grid item container xs={4} justifyContent={'flex-end'}>
                    <Grid item>
                        <CancelButtonStyled onClick={() => {
                            setPrefill(candidate);
                            openCreateDialog();
                        }}>
                            <FormattedMessage id={'shippingMethods.sylius.configure'}/>
                        </CancelButtonStyled>
                    </Grid>
                </Grid>
            </StyledLine>
        </Grid>
    );
}

export default SyliusCandidateLine;
